module.exports = __webpack_public_path__ + "static/Reign_and_Ruin_Standalone_rules-2cd53e05e7a74791c08fd14893addeb0.pdf";